import { AlertTriangle } from "lucide-react";

/**
 * Penanda "daftar terpotong" — SATU sumber dipakai lintas halaman Finance
 * (CLAUDE.md: "kalau butuh sesuatu di dua tempat, jadikan satu sumber").
 *
 * KENAPA ini perlu: banyak daftar Finance mengambil data lewat
 * `.sort(...).to_list(N)` di backend TANPA parameter urut dari klien
 * (mis. Piutang, Beban/utang-beban, mutasi Kas/Bank). Menempelkan header
 * kolom yang bisa diklik (`SortTh` dari `components/ui/sort.jsx`) di atas
 * daftar yang sudah dipotong itu HANYA mengurutkan baris yang kebetulan
 * terambil — kalau tidak diberi tahu, header itu "berbohong secara halus"
 * soal cakupannya (satu agent menolak memasang sort sama sekali karena
 * alasan ini; keputusan owner 21 Agu 2026: tetap pasang sort, TAPI wajib
 * jujur saat terpotong — lihat ringkasan pekerjaan gelombang sortir).
 *
 * DUA MODE:
 *  - `total` diketahui (backend mengirim hitungan penuh, mis. cashback
 *    claims yang menghitung sebelum memotong ke `limit`): tampil hanya kalau
 *    `total > shown`, dan angkanya PASTI karena datang dari server.
 *  - `total` tidak diketahui: pakai `batas` (angka `to_list(N)` di endpoint
 *    itu) sebagai penanda TIDAK PASTI — `shown >= batas` adalah tanda kuat
 *    (bukan bukti mutlak) bahwa ada baris lain yang tidak pernah sampai ke
 *    browser.
 */
export function BatasDaftarNotice({ shown, batas, total, testid = "list-batas-notice" }) {
  let pesan = null;
  if (Number.isFinite(total)) {
    if (total > shown) {
      pesan = `Menampilkan ${shown} dari total ${total} data — pengurutan kolom hanya berlaku untuk baris yang tampil di sini.`;
    }
  } else if (Number.isFinite(batas) && Number.isFinite(shown) && shown >= batas && shown > 0) {
    pesan = `Menampilkan ${shown} data terbanyak dari server — mungkin ada data lain yang belum tampil. Pengurutan kolom hanya berlaku untuk baris di sini.`;
  }
  if (!pesan) return null;
  return (
    <div
      className="px-4 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-800 flex items-center gap-1.5"
      data-testid={testid}
    >
      <AlertTriangle className="w-3.5 h-3.5 shrink-0" />
      {pesan}
    </div>
  );
}
